import { fetchApi } from './index';

export const checkFeatureFlag = (flagName: string): Promise<boolean> => {
  return fetchApi(`/api/featureFlags/${flagName}`, {}).then(async (response) => {
    return (await response.json()) as boolean;
  });
};
